<template>
    <highcharts v-if="series.length>0" :options="options"></highcharts>
</template>

<script>
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import stockInit from 'highcharts/modules/stock'

exportingInit(Highcharts)
stockInit(Highcharts)
// highchart 數值加上千分位逗號
Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
    downloadPNG: '下載成PNG',
    downloadJPEG: '下載成JPEG',
    downloadPDF: '下載成PDF',
    downloadSVG: '下載成SVG'
  },
  exporting: {
    enabled: true,
    buttons: {
      contextButton: {
        menuItems: ['downloadPNG', 'downloadJPEG', 'downloadSVG']
      }
    }
  }
})

export default {
  name: 'OutComeUuChart',
  props: ['series'],
  computed: {
    options () {
      return {
        template: {
          chart: {
            type: 'column',
            inverted: false,
            polar: false
          }
        },
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        series: this.series,
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false
            },
            animation: false
          }
        },
        chart: {
          type: 'column',
          polar: false,
          inverted: true,
          spacingTop: -80,
          spacingLeft: 0,
          spacingBottom: 20,
          style: {
            fontFamily: 'Arial',
            color: '#333',
            fontSize: '14px',
            fontWeight: 'normal',
            fontStyle: 'normal'
          },
          height: 320,
          width: null,
          backgroundColor: 'transparent'
        },
        credits: {
          enabled: false
        },
        colors: [
          '#7bbaff',
          '#4da1ff',
          '#ffffff',
          '#ffb14e',
          '#e89022'
        ],
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'bottom',
          itemMarginBottom: 4,
          enabled: true,
          floating: true,
          itemStyle: {
            fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif',
            color: '#333333',
            fontSize: '12px',
            fontWeight: 'normal',
            fontStyle: 'normal',
            cursor: 'pointer'
          },
          padding: 0
        },
        yAxis: [
          {
            type: 'linear',
            title: {
              text: ' '
            },
            labels: {
              format: ' '
            },
            gridLineColor: 'null'
          }
        ],
        xAxis: [
          {
            type: 'category',
            reversed: true,
            labels: {
              format: ' '
            },
            title: {
              text: ' '
            }
          }
        ],
        tooltip: {
          enabled: true,
          shared: false,
          borderWidth: 1
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
